import { Outlet } from 'react-router-dom';
import Footer from '../partials/Footer';
import Header from '../partials/Header';

const LayoutSimple = (props) => {


    return(
        <>
            <div id='home'>
                <Header/>
            </div>
            <Outlet/>
            <Footer/>
        </>
    )
}

export default LayoutSimple;